import script from "./AudienceFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./AudienceFilters.vue?vue&type=script&setup=true&lang=js"

import "./AudienceFilters.vue?vue&type=style&index=0&id=29358cd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29358cd8"]])

export default __exports__